export const GET_DOCUMENT_TYPES = "GET_DOCUMENT_TYPES";